export const ACTION_AUDIT_LOG = {
    EDIT_RESERVATION: 'edit_reservation',
    EDIT_PRICE_ADJUSTMENT: 'edit_price_adjustment',
    EDIT_IDLING_PENALTY: 'edit_idling_penalty',
    ADD_RESTRICTED_USER: 'add_restricted_user',
    ENABLE_SUBSCRIPTION_PLANS: 'enable_subscription_plans',
};
